// API url based on environment
let apiUrl
let mediaUrl
let adesionUrl
let simulationUrl
let pageUrl

switch (process.env.ADENE_ENV) {
  case 'localhost':
    apiUrl = `http://localhost:8000/api/v1`
    simulationUrl = `http://localhost:8000/api/v1`
    adesionUrl = `http://localhost:8000/api/v1`
    mediaUrl = `https://teste.poupaenergia.pt`
    pageUrl = `https://teste.poupaenergia.pt`
    break
  case 'development':
    apiUrl = `https://teste.poupaenergia.pt/d/api/v1`
    simulationUrl = `https://teste.poupaenergia.pt/s/api/v1`
    adesionUrl = `https://teste.poupaenergia.pt/d/api/v1`
    mediaUrl = `https://teste.poupaenergia.pt`
    pageUrl = `https://teste.poupaenergia.pt`
    break
  case 'production':
    apiUrl = `https://api.poupaenergia.pt/api/v1`
    simulationUrl = `https://api.poupaenergia.pt/s/api/v1`
    adesionUrl = `https://api.poupaenergia.pt/api/v1`
    mediaUrl = `https://api.poupaenergia.pt`
    pageUrl = `https://poupaenergia.pt`
    break
  case 'qa':
    apiUrl = `https://teste.poupaenergia.pt/d/api/v1`
    simulationUrl = `https://teste.poupaenergia.pt/s/api/v1`
    adesionUrl = `https://teste.poupaenergia.pt/d/api/v1`
    mediaUrl = `https://teste.poupaenergia.pt`
    pageUrl = `https://teste.poupaenergia.pt`
    break
  default:
    apiUrl = `https://teste.poupaenergia.pt/d/api/v1`
    simulationUrl = `https://teste.poupaenergia.pt/s/api/v1`
    adesionUrl = `https://teste.poupaenergia.pt/d/api/v1`
    mediaUrl = `https://teste.poupaenergia.pt`
    pageUrl = `https://teste.poupaenergia.pt`
}

export const API_SIMULATION_URL = simulationUrl
export const API_BASE_URL = apiUrl
export const MEDIA_BASE_URL = mediaUrl
export const SENTRY_URL = `https://3ede0aa3ebbe493f847d75de623c477d@sentry2.ubiwhere.com/39`
export const GOOGLE_KEY = `AIzaSyDgx1R-ss1J4w5hJNqd49Xxaxe-QP-lJIQ`
export const ADESION_URL = adesionUrl
export const PAGE_URL = pageUrl

export const SIMULATOR_TYPE = (function () {
  const advanced = document.getElementById('adene-simulador-avancado')
  const simple = document.getElementById('adene-simulador-simples')
  const enterprise = document.getElementById('adene-simulador-empresarial')

  if (advanced) return 'advanced'
  if (simple) return 'simple'
  if (enterprise) return 'enterprise'
}())

export const tipsWidget = document.getElementById('sa-random-tips-widget')

export const isAdvanced = (function () {
  const advanced = document.getElementById('adene-simulador-avancado')
  return !!advanced
}())

export const isSimple = (function () {
  const simples = document.getElementById('adene-simulador-simples')
  return !!simples
}())

export const isEnterprise = (function () {
  const enterprise = document.getElementById('adene-simulador-empresarial')
  return !!enterprise
}())

export const backgroundColors = (function () {
  return {
    normalLeft: (isEnterprise) ? 'linear-gradient(270deg,#006756,#7ed068),linear-gradient(270deg,#006736,#93c13e)' : 'linear-gradient(270deg, #006736 0%, #93C13E 100%)',
    normalRight: (isEnterprise) ? 'linear-gradient(270deg,#7ed068,#006756),linear-gradient(270deg,#93c13e,#006736)' : 'linear-gradient(270deg, #93C13E 0%, #006736 100%)',
    overLeftLeft: (isEnterprise) ? 'linear-gradient(270deg,#006756 0%,#7ed068 90%),linear-gradient(270deg,#006736 0%,#93c13e 90%)' : 'linear-gradient(270deg, #006736 0%, #93C13E 90%)',
    overRightLeft: (isEnterprise) ? 'linear-gradient(270deg,#7ed068 0%,#006756 90%),linear-gradient(270deg,#93c13e 0%,#006736 90%)' : 'linear-gradient(270deg, #93C13E 0%, #006736 90%)',
    overLeftRight: (isEnterprise) ? 'linear-gradient(270deg,#006756 10%,#7ed068 100%),linear-gradient(270deg,#006736 10%,#93c13e 100%)' : 'linear-gradient(270deg, #006736 10%, #93C13E 100%)',
    overRightRight: (isEnterprise) ? 'linear-gradient(270deg,#7ed068 10%,#006756 100%),linear-gradient(270deg,#93c13e 10%,#006736 100%)' : 'linear-gradient(270deg, #93C13E 10%, #006736 100%)'
  }
}())

export const ELECTRICITY_OFFER_TYPE = 'e'
export const GAS_OFFER_TYPE = 'g'
export const GAS_AND_ELECTRICITY_OFFER_TYPE = 'eg'

export const BOOLEAN_CHOICES = [
  {
    text: 'SIM',
    value: true
  },
  {
    text: 'NÃO',
    value: false
  }
]



// WEBPACK FOOTER //
// ./src/config.js